import React from "react";
import {
    Breadcrumb,
    Button,
    Checkbox,
    Col,
    ControlLabel,
    Form,
    FormControl,
    FormGroup,
    Modal,
    Row
} from "react-bootstrap";
import {LinkContainer} from "react-router-bootstrap";
import locale from "locale";
import axios from "axios";
import {CKEditor} from "ckeditor4-react";
import Loading from "../Loading";
import {ucFirst} from "../../../admin/js/lib";

class EmailSettings extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            isSaving: false,
            previewUrl: false,
            subjectRu: '',
            subjectEn: '',
            bodyRu: '',
            bodyEn: '',
            watchButton: false,
            offlineButton: false,
            calendarButton: false,
            testSystemButton: false,
            settings: null,
        };
    }

    componentDidMount()
    {
        const {event, type} = this.props;

        this.setState({isLoading: true});

        axios.get(`/api/cp/event/${event.eventPassword}/emailSettings/${type}`)
            .then(response => response.data)
            .then(settings => {
                this.setState({
                    isLoading: false,
                    settings,
                    subjectRu: settings.subjectRu,
                    subjectEn: settings.subjectEn,
                    bodyRu: settings.bodyRu,
                    bodyEn: settings.bodyEn,
                    watchButton: settings.watchButton,
                    offlineButton: settings.offlineButton,
                    calendarButton: settings.calendarButton,
                    testSystemButton: settings.testSystemButton,
                })
            });
    }

    saveProperty(name, value)
    {
        if (this.state.settings[name] === value) {
            return;
        }

        const {event, type} = this.props;

        this.setState({isSaving: true});

        axios.put(`/api/cp/event/${event.eventPassword}/emailSettings/${type}`, {[name]: value})
            .then(() => {
                const settings = Object.assign({}, this.state.settings, {[name]: value});
                this.setState({settings, isSaving: false});
            })
            .catch(error => {
                if (error.response?.data?.message) {
                    alert(error.response.data.message);
                }
            })
        ;
    }

    changeProperty(name, value)
    {
        this.setState({[name]: value});
    }

    showPreview(lang)
    {
        const {event, type} = this.props;

        const previewUrl = `/api/cp/event/${event.eventPassword}/emailSettings/${type}/preview?lang=${lang}`;

        this.setState({previewUrl});
    }

    hidePreview()
    {
        this.setState({previewUrl: false});
    }

    render()
    {
        const {event, type} = this.props;
        const {isLoading, previewUrl} = this.state;

        const placeholders = [
            ...(this.props.placeholders || []),
            "watchUrl",
            "eventName",
            "dateStart",
            "timeStart",
            "dateStop",
            "timeStop",
            "userName",
            ...event.registrationFields.map(({field}) => 'user' + ucFirst(field.name)),
        ];

        if (isLoading) {
            return <Loading />;
        }

        return (
            <section>
                <Breadcrumb>
                    <LinkContainer to={`/event/${event.eventPassword}`}><Breadcrumb.Item>Трансляция</Breadcrumb.Item></LinkContainer>
                    <Breadcrumb.Item active>{locale('mainMenu.emails')}</Breadcrumb.Item>
                    <Breadcrumb.Item active>{locale(`mainMenu.emails.${type}`)}</Breadcrumb.Item>
                </Breadcrumb>

                <Form>
                    <FormGroup>
                        <Row>
                            <Col xs={6}>
                                <ControlLabel>Тема письма [Ru]</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={this.state.subjectRu}
                                    onChange={e => this.changeProperty('subjectRu', e.target.value)}
                                    onBlur={e => this.saveProperty('subjectRu', e.target.value)}
                                    placeholder={'Тема письма [Ru]'}
                                />
                            </Col>
                            <Col xs={6}>
                                <ControlLabel>Тема письма [En]</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={this.state.subjectEn}
                                    onChange={e => this.changeProperty('subjectEn', e.target.value)}
                                    onBlur={e => this.saveProperty('subjectEn', e.target.value)}
                                    placeholder={'Тема письма [En]'}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <ControlLabel>Тело письма [Ru]</ControlLabel>
                                <CKEditor
                                    initData={this.state.bodyRu}
                                    onChange={(e) => this.changeProperty('bodyRu', e.editor.getData())}
                                    onBlur={(e) => this.saveProperty('bodyRu', e.editor.getData())}
                                />
                                <p>
                                    Доступные значения: {placeholders.map(name => `{{${name}}}`).join(', ')}
                                </p>
                            </Col>
                            <Col xs={6}>
                                <ControlLabel>Тело письма [En]</ControlLabel>
                                <CKEditor
                                    initData={this.state.bodyEn}
                                    onChange={(e) => this.changeProperty('bodyEn', e.editor.getData())}
                                    onBlur={(e) => this.saveProperty('bodyEn', e.editor.getData())}
                                />
                                <p>
                                    Доступные значения: {placeholders.map(name => `{{${name}}}`).join(', ')}
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <Checkbox
                                    checked={this.state.watchButton}
                                    onChange={e => {
                                        this.changeProperty('watchButton', e.target.checked);
                                        this.saveProperty('watchButton', e.target.checked);
                                    }}
                                >Кнопка "Смотреть"</Checkbox>
                                <Checkbox
                                    checked={this.state.offlineButton}
                                    onChange={e => {
                                        this.changeProperty('offlineButton', e.target.checked);
                                        this.saveProperty('offlineButton', e.target.checked);
                                    }}
                                >Кнопка "Офлайн участия"</Checkbox>
                                <Checkbox
                                    checked={this.state.calendarButton}
                                    onChange={e => {
                                        this.changeProperty('calendarButton', e.target.checked);
                                        this.saveProperty('calendarButton', e.target.checked);
                                    }}
                                >Кнопка "Добавить в календарь"</Checkbox>
                                <Checkbox
                                    checked={this.state.testSystemButton}
                                    onChange={e => {
                                        this.changeProperty('testSystemButton', e.target.checked);
                                        this.saveProperty('testSystemButton', e.target.checked);
                                    }}
                                >Кнопка "Проверить подключение"</Checkbox>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <Button disabled={this.state.isSaving} onClick={() => this.showPreview("ru")}>Просмотр</Button>
                            </Col>
                            <Col xs={6}>
                                <Button disabled={this.state.isSaving} onClick={() => this.showPreview("en")}>Просмотр</Button>
                            </Col>
                        </Row>
                    </FormGroup>
                </Form>
                <Modal show={!!previewUrl} onHide={() => this.hidePreview()} bsSize="large">
                    <Modal.Header closeButton>
                        <Modal.Title>Предпросмотр письма</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <iframe src={previewUrl} width="100%" height="600" frameBorder={0} />
                    </Modal.Body>
                </Modal>
            </section>
        );
    }
}

export default EmailSettings;
